import React from 'react';
import { connect } from 'react-redux';
import { PageSection } from 'adc-ui-components';
import { Link } from 'react-router-dom';

import Card from '../../components/Card';
import OrderDetails from '../../components/OrderDetails';
import DeviceUpdateDetails from '../../components/DeviceUpdateDetails';
import HowToReturnOldEquipment from '../../components/HowToReturnOldEquipment';
import NoMatch from '../Errors/NoMatch';
import { getConfirmationDetails, mergeSwapDevices, getEligibleDevices } from '../../helpers/swaps';
import { getDeviceFromAccount } from '../../helpers/account';
import { RETURNS } from '../../helpers/routes';

const status = (
  <span className="status status--warning">Order In Progress</span>
);

const SwapsDetail = ({
  account,
  macaroon,
  order,
  isEligible,
}) => {
  if (!order) {
    return <NoMatch />;
  }

  return (
    <PageSection>
      <h1 className="heading2 mb24">Your order is in Progress!</h1>
      <OrderDetails
        title={`Order # ${order.orderId}`}
        details={getConfirmationDetails(account, macaroon, order)}
        action={status}
      >
        <div className="card-group__item">
          <Card className="card--secondary">
            <p>
              {'You can track your order from '}
              <Link href={RETURNS}>My Account</Link>
            </p>
          </Card>
        </div>
      </OrderDetails>

      {order.devices.length > 0
        && <DeviceUpdateDetails devices={order.devices} isEligible={isEligible} />
      }
      <HowToReturnOldEquipment className="mb24" />

      <div className="action action--centered">
        <a className="button" href="/">Back to My Account</a>
      </div>
    </PageSection>
  );
};

const mapStateToProps = (state, ownProps) => {
  const {
    swaps: { data: { orders = [] } = {}, loading },
    account: { data: account },
    auth: { macaroon },
    swapEligibility: {
      data: { devices: swapDevices = [] } = {},
    },
  } = state;

  const { match: { params: { id } } } = ownProps;

  let order = orders.find(ordr => ordr.orderId === id);
  const accountDevices = getDeviceFromAccount(account);

  if (order) {
    order = {
      ...order,
      devices: mergeSwapDevices(order, accountDevices),
    };
  }

  const eligibleDevices = getEligibleDevices({ devices: swapDevices }, accountDevices);
  const isEligible = eligibleDevices.length > 0;

  return {
    account,
    macaroon,
    order,
    loading,
    isEligible,
  };
};

export default connect(mapStateToProps)(SwapsDetail);
